<template>
  <div>
    <Head title="Local Purchase Orders" />
    <div class="flex items-center justify-between mb-6 mt-6 overflow-x-auto">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-orange-400 hover:text-orange-600" href="/list/purchase-orders">
          Local Purchase Orders
        </Link>
        <span class="text-orange-400 font-medium">/</span>View
      </h1>
      <div class="flex items-end justify-end space-x-3">
        <!--<button v-show="purchaseOrder.status ==='Placed'" class="btn-orange" @click="receiveOrderModel">
          <span>Receive</span>
        </button>-->
        <Link
          v-show="purchaseOrder.status ==='Pending Approval' || purchaseOrder.status ==='Planned'"
          class="btn-orange"
          :href="`/purchaseOrders/${purchaseOrder.id}/edit`"
        >
          <span>Edit</span>
        </Link>
        <!--<Link v-show="purchaseOrder.status ==='Booked'" class="btn-orange" @click="receiveOrderModel(purchaseOrder)">
          <span>Receive</span>
        </Link>-->
        <a
          class="btn btn-orange text-xs cursor-pointer"
          :href="`/purchase-orders/${purchaseOrder.id}/pdf${url()}`" 
          download
          target="__blank"
          title="Download"
        >
          <span>Download PDF</span>
        </a>
      </div>
    </div>
    <div class="flex items-center justify-center min-h-screen bg-white-100">
      <div class="w-full bg-white shadow-lg">
        <div class="w-full h-0.5 bg-gray-200"></div>
        <div class="flex p-0">
          <div class="w-full lg:w-1/3">
            <img src="/images/water_vale.png" style="height: 100px;">
          </div>
          <div class="p-2 w-full lg:w-2/3">
            <span class="text-sm">
              {{ company.address }} <br>
            </span>
            <span class="text-sm">
              {{ company.region }} <br>
            </span>
            <span class="text-sm">
              {{ company.email }} <br>
            </span>
            <span class="text-sm">
              {{ company.phone_number }}<br>
            </span>
          </div>
        </div>
        <div class="w-full items-center border-2 border-gray-700 border-l-gray-700">
          <h1 class="text-2xl font-bold text-center">Purchase Order</h1>
        </div>
        <div class="flex p-5 justify-between">
          <div class="flex flex-wrap w-full lg:w-full">
            <div class="pb-2 pr-1 w-full lg:w-1/2">
              <span class="font-bold"> PURCHASER: </span>
                <span class="text-sm">
                  <br>{{ company.company }}
                </span>
                <span class="text-sm">
                 <br> {{ company.address }} <br>
                </span>
                <span class="text-sm">
                  {{ company.region }} <br>
                </span>
                <span class="text-sm">
                  Telephone: {{ company.phone_number }}<br>
                </span>
            </div>
            <div class="pb-2 pr-1 w-full lg:w-1/2">
              <span class="font-bold"> SELLER: </span>
              <span class="text-sm">
                <br>{{ supplier.name }}
              </span>
            </div>
          </div>
        </div>
        <div class="flex w-full mt-4">
          <div class="w-full overflow-x-auto">
            <table class="w-full border-collapse border border-gray-700 border-slate-700">
              <thead>
                <tr>
                  <th class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                    PO No.
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Document Date
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Payment Method
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Delivery Terms
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">{{ purchaseOrder.PO_number }}</td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">{{ purchaseOrder.created_on }}</td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="flex w-full mt-4">
          <div class="w-full overflow-x-auto">
            <table class="w-full border-collapse border border-gray-700 border-slate-700">
              <thead>
                <tr>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Item No.
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Goods/services offered
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Description
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Quantity
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-7000">
                    Units
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Purchase Price({{ currency }})
                  </th>
                  <th class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    Subtotal
                  </th>
                </tr>
              </thead>
              <tbody class="bg-white">
                <tr  v-for="(orderedProduct, index) in orderedProducts" :key="orderedProduct.id">
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                    {{ index + 1 }}
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    {{ orderedProduct.part_number }}:{{ orderedProduct.goods_service_offered }}
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">
                    {{ orderedProduct.description }}
                  </td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700 text-right">
                    {{ orderedProduct.quantity }}
                  </td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700">
                    {{ orderedProduct.unit_of_measure }}
                  </td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700 text-right">
                    {{ orderedProduct.unit_price }}
                  </td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700 text-right">
                    {{ orderedProduct.total }}
                  </td>
                </tr>
                <tr
                  v-for="val in [1,2,3,4,5,6,7,8]"
                  :key="`d-${val}`">
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                </tr>
                <tr v-show="has_vat == 'yes'">
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700" colspan="3">
                    SUBTOTAL
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">{{ currency }}. <span class="text-right">{{ overal_total }}</span></td>
                </tr>
                <tr v-show="has_vat == 'no'">
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700" colspan="3">
                    SUBTOTAL
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">{{ currency }}. <span class="text-right">{{ overal_total }}</span></td>
                </tr>
                <tr v-show="has_vat == 'yes'">
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700" colspan="3">
                    VAT({{ vat }}%)
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700">{{ currency }}. <span class="text-right">{{ vat_total }}</span></td>
                </tr>
                <tr>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700"></td>
                  <td class="px-1 py-2 text-sm text-center border border-gray-700 border-slate-700 font-bold" colspan="3">
                    <span>TOTAL</span>
                  </td>
                  <td class="px-1 py-2 text-sm border border-gray-700 border-slate-700 font-bold">{{ currency }}. <b class="text-right">{{ overal_total_plus_vat }}</b></td>
                </tr>
              </tbody>
            </table>
            <img src="/images/stamp.png" style="height: 200px; width: auto; margin-top: -157px;margin-left: 90px;">
          </div>
        </div>
        <div class="w-full h-0.5 bg-orange-500 mt-5"></div>
      </div>
      <!--modal content-->
      <div class="fixed z-10 inset-0 overflow-y-auto" v-if="isOpen">
        <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div class="fixed inset-0 transition-opacity">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
          </div>
          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
          <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <form>
              <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div class="mb-4">
                  <text-input v-model="form.GRN_number" type="text" :error="errors.GRN_number" class="pb-8 pr-6 w-full lg:w-full" label="GRN Number" />
                </div>
              </div>
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button type="button" @click="receiveOrder()" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-orange-500 text-base leading-6 font-medium text-white shadow-sm hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange sm:text-sm sm:leading-5">
                   Receive
                 </button>
               </span>
              <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                <button @click="closeModal" type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5">
                  Cancel
                </button>
              </span>
            </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'

export default {
  components: {
    Head,
    Link,
    Icon,
    TextInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    purchaseOrder: Object,
    orderedProducts: Object,
    supplier: Array,
    overal_total: String,
    errors: Object,
    company: Object,
    vat_total: String,
    vat: String,
    has_vat: String,
    overal_total_plus_vat: String,
    currency: String,
  },
  data() {
    return {
      isOpen: false,
      GRN_number: null,
      form: this.$inertia.form({
        GRN_number: null,
      }),
    }
  },
  methods: {
    receiveOrder() {
      const data = {};
      data.purchase_order_id = this.purchaseOrder.id;
      data.supplier_id = this.purchaseOrder.supplier_id;
      data.GRN_number = this.form.GRN_number;
      // data._method = 'POST';
      // this.$inertia.post(`/suppliers/${data.supplier_id}/purchaseOrders/${data.purchase_order_id}/receive`, data)
    },
    receiveOrderModel() {
      this.isOpen = true;
    },
    closeModal() {
      this.isOpen = false;
    },
    url() {
      let query = ''
      if (this.purchaseOrder) {
        query += `pid=${this.purchaseOrder.id}`
      }
      if (this.purchaseOrder.type) {
        if (query) {
          query += '&'
        }
        query += `type=${this.purchaseOrder.type}`
      }
      if (query) {
        query = `?${query}`
      }
      return query
    },
  },
}
</script>
